import React, { useEffect } from 'react';
import './BotonCerrarSesion.css';

const BotonCerrarSesion = (props) => {
    const { servicio, setCargando, marca, servicioFirebase } = props;
    useEffect(() => {
    }, []);

    return (
        <div onClick={() => {
            if (marca !== process.env.REACT_APP_MARCA_VW) {
                servicioFirebase.registrarEventoPersonalizadoAnalitica("action-cerrar-sesion", { marca: marca, descripcion: "Cierre de Sesion" });
            }
            setCargando(true);

            let pagina = ""
            switch (marca) {
                case "seat":
                    pagina = process.env.REACT_APP_LOGOUT_REDIRECT_SEAT
                    break;
                case "audi":
                    pagina = process.env.REACT_APP_LOGOUT_REDIRECT_AUDI
                    break;
                case "cupra":
                    pagina = process.env.REACT_APP_LOGOUT_REDIRECT_CUPRA
                    break;
                default:
                    pagina = process.env.REACT_APP_LOGOUT_REDIRECT
                    break;
            }

            servicio.cerrarSesion(pagina).then(data => { setCargando(false); window.location = data }).catch(err => { setCargando(false); console.log(err); })
        }}
            className="boton-cerrar-sesion">Cerrar sesión</div>
    )
}
export default BotonCerrarSesion;